module.exports = __webpack_public_path__ + "static/horsak-36f36329869041af58035523e8b0cb58.jpg";